module.exports = __webpack_public_path__ + "integration-slimcd-icon.png?74dfe436db9f47d8a67b4d4b35ed8900";